import HeartWaveMark from "@/components/ui/HeartWaveMark";

/**
 * Minimalist editorial divider with the brand heart-wave mark centered.
 * Used as a subtle, professional pause between sections.
 */
export default function SectionDivider({ label }) {
  return (
    <div className="relative max-w-7xl mx-auto px-6 md:px-10 py-10">
      <div className="flex items-center gap-5 text-editorial-gray/50">
        <span className="flex-1 h-px bg-editorial-gray/20" />
        <span className="inline-flex items-center gap-2.5 text-[0.7rem] tracking-[0.28em] uppercase">
          <HeartWaveMark className="w-5 h-5 text-accent-magenta/80" strokeWidth={1.4} />
          {label && <span>{label}</span>}
        </span>
        <span className="flex-1 h-px bg-editorial-gray/20" />
      </div>
    </div>
  );
}
